import { intersection } from 'lodash'

export type Intersection = typeof intersection

export const arrayIntersection: Intersection = intersection
